export const habaContactForm = {
  habaContactForm: {
    success: {
      title: 'Vielen Dank für Ihre Anfrage',
      txt: 'Wir werden Ihr Anliegen so schnell wie möglich bearbeiten'
    },
    messages: {
      notValidError: 'Ungültige Eingaben',
      serverError: 'Es ist ein unbekannter Fehler aufgetreten'
    },
    form: {
      legend: 'Kontaktformular',
      reason: {
        label: 'Grund Ihrer Anfrage',
        error: 'Bitte Grund Ihrer Anfrage auswählen'
      },
      reference: {
        label: 'Betreff',
        error: 'Bitte Betreff eingeben'
      },
      file: {
        label: 'Datei hochladen (optional)',
        button: 'Daten hinzufügen',
        error: 'Bitte eine Datei auswählen',
        additionalInformation: 'Erlaubte Dateien: .pdf, .jpg, .jpeg, .png (Gesamtgröße max 15 MB)'
      },
      message: {
        label: 'Ihre Nachricht',
        error: 'Bitte geben sie ihre Nachricht ein'
      },
      customerType: {
        firm: 'Firma',
        institution: 'Einrichtung',
        private: 'Privatperson'
      },
      name: {
        label: 'Name',
        error: 'Bitte Name eingeben'
      },
      firstName: {
        label: 'Vorname',
        error: 'Bitte Vorname eingeben'
      },
      lastName: {
        label: 'Nachname',
        error: 'Bitte Nachname eingeben'
      },
      customerNumber: {
        label: 'Kundennummer (optional)',
        error: 'Bitte gültige Kundennummer eingeben'
      },
      orderNumber: {
        label: 'Auftragsnummer (optional)',
        error: 'Bitte gültige Bestellnummer eingeben'
      },
      street: {
        label: 'Straße',
        error: 'Bitte Straße eingeben'
      },
      houseNumber: {
        label: 'Hausnummer',
        error: 'Bitte Hausnummer eingeben'
      },
      postcode: {
        label: 'PLZ',
        error: 'Bitte PLZ eingeben'
      },
      location: {
        label: 'Ort',
        error: 'Bitte Ort eingeben'
      },
      country: {
        label: 'Land',
        error: 'Bitte Land auswählen'
      },
      email: {
        label: 'E-Mail Adresse',
        error: 'Bitte E-Mail Adresse auswählen'
      },
      phone: {
        label: 'Telefonnummer',
        error: 'Bitte Telefonnummer eingeben',
        formatError:
          'Bitte geben Sie eine gültige Telefonnummer ein (7–20 Zeichen, nur Ziffern und + - / , ( ) sind erlaubt).'
      },
      isAgreed: {
        label:
          'Ich willige ein, dass meine persönlichen Angaben sowie meine Nachricht, ausschließlich zum Zwecke der Bearbeitung und Abwicklung meiner Anfrage verarbeitet werden. Diese Daten werden auf Grundlage von Art. 6 Abs. 1 lit. a bzw. Art. 6 Abs. 1 lit. b DSGVO verarbeitet (vgl. <strong>Datenschutzerklärung</strong>)',
        error: ''
      },
      submit: 'Absenden',
      submitRequest: 'Rückruf anfordern'
    },
    formProductAdvisor: {
      description: 'Füllen Sie das Formular aus und ein Berater meldet sich bei Ihnen.',
      contactUs: 'Kontaktieren Sie uns',
      option: {
        description: 'Wählen Sie Ihre bevorzugte Kontaktmöglichkeit',
        message: 'Nachricht schreiben',
        call: 'Anrufen',
        mail: 'E-Mail senden',
      },
    },
    whenStuck: 'Wenn sie nicht weiterkommen, dann nutzen Sie bitte das ',
    formular: 'Formular',
    whenStuckEnglish: 'If you get stuck, please use the ',
    formularEnglish: 'form'
  }
};
